import * as Joi from "joi-browser";
import { MdInfoOutline } from "react-icons/md";
import { Col } from "react-bootstrap";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import exclamation from "../assets/img/exclamation.svg";
import moment from "moment";
import tickIcon from "../assets/img/tickIcon.png";
import exclamationIcon from "../assets/img/exclamationIcon.png";
import { BsAmd } from "react-icons/bs";

export const haveValue = (val) => {
  if (
    val !== "" &&
    val !== "undefined" &&
    val !== undefined &&
    val !== null &&
    val !== "null"
  ) {
    return true;
  } else {
    return false;
  }
};

export const withBackendUrl = (path, defaultPath = null) => {
  if (typeof path === "object") {
    let src = URL.createObjectURL(path);
    return src;
  } else {
    if (haveValue(path)) {
      path = path?.toString();
      if (path?.startsWith("http://") || path?.startsWith("https://")) {
        return path;
      } else {
        if (path.startsWith("/")) {
          path = path.substring(1);
        }
        return process.env.REACT_APP_SERVER_URL + "/" + path;
      }
    } else {
      return "";
    }
  }
};
export const toLowerCase = (data) => {
  return data.toString().toLowerCase();
};

export const convertCurrencyFormat = (amount) => {
  return new Intl.NumberFormat(localStorage.getItem("i18nextLng"), {
    currency: localStorage.getItem("i18nextLng") === "es" ? "EUR" : "USD",
  }).format(amount);
};

export const toUpperCase = (data) => {
  return data.toString().toUpperCase();
};

export const validateJOIFormField = (formFields, schema) => {
  const result = Joi.validate(formFields, schema, {
    abortEarly: false,
    stripUnknown: true,
  });
  const { error } = result;
  if (!error) {
    return null;
  } else {
    const errorData = {};
    for (let item of error.details) {
      const name = item.path[0];
      errorData[name] = item.message;
    }
    return errorData;
  }
};

export const validateJOIProperty = (schema, event) => {
  const { name, value } = event.target;
  console.log(value, "check iban value");
  const obj = { [name]: value };
  if (schema.hasOwnProperty(name)) {
    const subSchema = { [name]: schema[name] };
    const result = Joi.validate(obj, subSchema, {
      stripUnknown: true,
    });
    const { error } = result;
    return error ? error.details[0].message : null;
  } else {
    return null;
  }
};

export const renderErrorMessage = (errors, type) => {
  if (errors && errors[type]) {
    return errors[type];
  }
  return "";
};

export const getBaseUrl = () => {
  const baseUrl = `${window.location.protocol}//${window.location.host}`;
  return baseUrl;
};

export const truncateString = (str, maxLength = 100) => {
  if (str.length > maxLength) {
    return str.substring(0, maxLength) + "...";
  }
  return str;
};

export const skipMaccUser = (user_type = null) => {
  switch (user_type) {
    case "macc":
      return true;
    default:
      return false;
  }
};

export const verifyDniNie = (user, nie_val) => {
  var result = false;
  if (user?.onfido_kyc_success) {
    if (user?.onfido_user_kyc?.onfido_doc_data?.personal_number == nie_val) {
      result = true;
    }
  }
  if (result == false) {
    if (user?.dni_nie == nie_val) {
      result = true;
    }
  }
  return result;
};

export const fetchCompanyName = (user, _t) => {
  var found = false;
  var res = null;
  if (haveValue(user?.vida_laboral_id)) {
    const response = user?.vida_laboral_id?.response;

    if (verifyDniNie(user, response?.informacionPersonal?.identificacion)) {
      const companyArr = user?.vida_laboral_id?.response?.situaciones;
      var company_name = null;
      for (let val of companyArr) {
        if (!haveValue(val?.fechaBaja)) {
          company_name = haveValue(val?.nombreEmpresa)
            ? val?.nombreEmpresa
            : "";
          break;
        }
      }
      if (haveValue(company_name)) {
        found = true;
        res = { type: "Vida Laboral", val: company_name };
      }
    }
  }
  if (
    found == false &&
    haveValue(user?.algoanIncome?.employers) &&
    user?.algoanIncome?.employers.length > 0
  ) {
    found = true;
    res = { type: "Bank", val: user?.algoanIncome?.employers[0]?.name };
  }
  if (found == false && haveValue(user?.name_of_company)) {
    found = true;
    res = { type: "", val: user?.name_of_company };
  }
  if (found == false) {
    res = null;
  }
  if (haveValue(res)) {
    return (
      <>
        <h4 className="d-flex gap-2 align-items-center">
          {_t("nameOfCompany")}
          {haveValue(res.type) && (
            <ul className="infodorpdown summarydropdum position-relative">
              <li>
                <button className="iconinfo">
                  <MdInfoOutline />
                </button>{" "}
              </li>
              <ul className="tooltip">
                <p>
                  {_t("from")} {_t(res.type)}
                </p>
              </ul>
            </ul>
          )}
          :
        </h4>
        <h3>
          <span>{res.val}</span>{" "}
          {haveValue(res.type) && <img src={tickIcon} alt="" />}
        </h3>
      </>
    );
  }
};

function getMonthKey(monthNumber) {
  const months = [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december",
  ];
  return months[monthNumber - 1];
}

const normalizeSalary = (value) => {
  if (typeof value === "string") {
    value = value.replace(/,/g, ""); // Remove commas
  }
  return Math.ceil(parseFloat(value));
};

export const checkPayslipData = (
  user,
  _t,
  highlightedPayslip,
  handlePayslipChange = () => { },
  allowIncomeSourceChange,
  showIncomeHighlight
) => {
  // console.log("data in payslip => tenant extra fields", user);
  let payslip_data = user?.tenant_extra_field_id?.payslip_data;
  // if (haveValue(user?.gurantor_id)) {
  //   payslip_data = user?.gurantor_id?.tenant_extra_field_id?.payslip_data;
  //   user = user?.gurantor_id;
  // }
  return (
    <>
      <Col md={5} style={{ width: "auto", flex: 1 }}>
        <div className="Score-content-list">
          <h4>{_t("incomeFromPayslip")}:</h4>
          {/* paslip 1 data */}
          {haveValue(payslip_data?.payslip1) &&
            verifyDniNie(user, payslip_data?.payslip1?.data?.nieDniNumber) &&
            (() => {
              const payslip = payslip_data?.payslip1?.data;
              const situaciones =
                user?.vida_laboral_id?.response?.situaciones || [];

              const empresaVida = situaciones[0]?.nombreEmpresa
                ?.split(" ")[0]
                ?.toLowerCase();
              const empresaPayslip = payslip?.employer
                ?.split(" ")[0]
                ?.toLowerCase();

              const isEmployerDataAvailable = !!empresaVida && !!empresaPayslip;
              const isEmployerMatch = empresaPayslip === empresaVida;

              const deductionData =
                user?.tenant_extra_field_id?.deduction_cert_data
                  ?.company_info || [];
              const payslipDate = payslip?.date;

              let isSalaryMatch = false;
              let isSalaryDataAvailable = false;

              if (payslipDate) {
                const [day, month, year] = payslipDate.includes("-")
                  ? payslipDate.split("-").length === 3 &&
                    payslipDate.split("-")[2].length === 4
                    ? payslipDate.split("-")
                    : payslipDate.split("-").reverse()
                  : ["", "", ""];

                const monthKey = getMonthKey(parseInt(month));
                const targetYear = year;

                for (const company of deductionData) {
                  const yearObj = company?.year;
                  const salaryValue = yearObj?.[targetYear]?.[monthKey];

                  if (salaryValue) {
                    isSalaryDataAvailable = true;

                    if (
                      normalizeSalary(salaryValue) ===
                      normalizeSalary(payslip?.netSalary)
                    ) {
                      isSalaryMatch = true;
                      break;
                    }
                  }
                }
              }

              const hasBothData =
                isEmployerDataAvailable && isSalaryDataAvailable;
              const hasAnyData =
                isEmployerDataAvailable || isSalaryDataAvailable;

              const isBothMatch = isEmployerMatch && isSalaryMatch;
              const isEitherMismatch =
                (isEmployerDataAvailable && !isEmployerMatch) ||
                (isSalaryDataAvailable && !isSalaryMatch);

              return (
                <div className="d-flex payslip-style">
                  <div
                    className={`d-flex payslip-style ${allowIncomeSourceChange ? "cursor-pointer" : ""
                      } ${showIncomeHighlight && highlightedPayslip === "payslip1"
                        ? "highlight-paymentslip"
                        : ""
                      }`}
                    onClick={() =>
                      allowIncomeSourceChange
                        ? handlePayslipChange("payslip1")
                        : {}
                    }
                  >
                    <span className="payslip-font-size-salary">
                      €{convertCurrencyFormat(payslip?.netSalary)}
                    </span>
                    <span className="paysip-date payslip-font-size">
                      {payslip?.date
                        ? `(${moment(payslip.date, "DD-MM-YYYY").format(
                          "MMM, YYYY"
                        )})`
                        : ""}
                    </span>
                  </div>

                  {!hasAnyData ? null : (hasBothData && isBothMatch) ||
                    (!isEmployerDataAvailable &&
                      isSalaryDataAvailable &&
                      isSalaryMatch) ||
                    (!isSalaryDataAvailable &&
                      isEmployerDataAvailable &&
                      isEmployerMatch) ? (
                    <img src={tickIcon} alt="match" />
                  ) : isEitherMismatch ? (
                    <ul className="infodorpdown summarydropdum position-relative">
                      <li>
                        <button className="iconinfo iconinfo2 m-0">
                          <img src={exclamationIcon} alt="mismatch" />
                        </button>
                      </li>
                      <ul className="tooltip tooltip2">
                        {isEmployerDataAvailable && !isEmployerMatch && (
                          <p>{_t("companyNotMatch")}</p>
                        )}
                        {isSalaryDataAvailable && !isSalaryMatch && (
                          <p>{_t("salaryMismatch")}</p>
                        )}
                      </ul>
                    </ul>
                  ) : null}
                </div>
              );
            })()}

          {/* paslip 2 data */}
          {haveValue(payslip_data?.payslip2) &&
            verifyDniNie(user, payslip_data?.payslip2?.data?.nieDniNumber) &&
            (() => {
              const payslip = payslip_data?.payslip2?.data;
              const situaciones =
                user?.vida_laboral_id?.response?.situaciones || [];

              const empresaVida = situaciones[0]?.nombreEmpresa
                ?.split(" ")[0]
                ?.toLowerCase();
              const empresaPayslip = payslip?.employer
                ?.split(" ")[0]
                ?.toLowerCase();

              const isEmployerDataAvailable = !!empresaVida && !!empresaPayslip;
              const isEmployerMatch = empresaPayslip === empresaVida;

              const deductionData =
                user?.tenant_extra_field_id?.deduction_cert_data
                  ?.company_info || [];
              const payslipDate = payslip?.date;

              let isSalaryMatch = false;
              let isSalaryDataAvailable = false;

              if (payslipDate) {
                const [day, month, year] = payslipDate.includes("-")
                  ? payslipDate.split("-").length === 3 &&
                    payslipDate.split("-")[2].length === 4
                    ? payslipDate.split("-")
                    : payslipDate.split("-").reverse()
                  : ["", "", ""];

                const monthKey = getMonthKey(parseInt(month));
                const targetYear = year;

                for (const company of deductionData) {
                  const yearObj = company?.year;
                  const salaryValue = yearObj?.[targetYear]?.[monthKey];

                  if (salaryValue) {
                    isSalaryDataAvailable = true;

                    if (
                      normalizeSalary(salaryValue) ===
                      normalizeSalary(payslip?.netSalary)
                    ) {
                      isSalaryMatch = true;
                      break;
                    }
                  }
                }
              }

              const hasBothData =
                isEmployerDataAvailable && isSalaryDataAvailable;
              const hasAnyData =
                isEmployerDataAvailable || isSalaryDataAvailable;

              const isBothMatch = isEmployerMatch && isSalaryMatch;
              const isEitherMismatch =
                (isEmployerDataAvailable && !isEmployerMatch) ||
                (isSalaryDataAvailable && !isSalaryMatch);

              return (
                <div className="d-flex payslip-style">
                  <div
                    className={`d-flex payslip-style ${allowIncomeSourceChange ? "cursor-pointer" : ""
                      } ${showIncomeHighlight && highlightedPayslip === "payslip2"
                        ? "highlight-paymentslip"
                        : ""
                      }`}
                    onClick={() =>
                      allowIncomeSourceChange
                        ? handlePayslipChange("payslip2")
                        : {}
                    }
                  >
                    <span className="payslip-font-size-salary">
                      €{convertCurrencyFormat(payslip?.netSalary)}
                    </span>
                    <span className="paysip-date payslip-font-size">
                      {payslip?.date
                        ? `(${moment(payslip.date, "DD-MM-YYYY").format(
                          "MMM, YYYY"
                        )})`
                        : ""}
                    </span>
                  </div>

                  {!hasAnyData ? null : (hasBothData && isBothMatch) ||
                    (!isEmployerDataAvailable &&
                      isSalaryDataAvailable &&
                      isSalaryMatch) ||
                    (!isSalaryDataAvailable &&
                      isEmployerDataAvailable &&
                      isEmployerMatch) ? (
                    <img src={tickIcon} alt="match" />
                  ) : isEitherMismatch ? (
                    <ul className="infodorpdown summarydropdum position-relative">
                      <li>
                        <button className="iconinfo iconinfo2 m-0">
                          <img src={exclamationIcon} alt="mismatch" />
                        </button>
                      </li>
                      <ul className="tooltip tooltip2">
                        {isEmployerDataAvailable && !isEmployerMatch && (
                          <p>{_t("companyNotMatch")}</p>
                        )}
                        {isSalaryDataAvailable && !isSalaryMatch && (
                          <p>{_t("salaryMismatch")}</p>
                        )}
                      </ul>
                    </ul>
                  ) : null}
                </div>
              );
            })()}

          {/* paslip 3 data */}
          {haveValue(payslip_data?.payslip3) &&
            verifyDniNie(user, payslip_data?.payslip3?.data?.nieDniNumber) &&
            (() => {
              const payslip = payslip_data?.payslip3?.data;
              const situaciones =
                user?.vida_laboral_id?.response?.situaciones || [];

              const empresaVida = situaciones[0]?.nombreEmpresa
                ?.split(" ")[0]
                ?.toLowerCase();
              const empresaPayslip = payslip?.employer
                ?.split(" ")[0]
                ?.toLowerCase();

              const isEmployerDataAvailable = !!empresaVida && !!empresaPayslip;
              const isEmployerMatch = empresaPayslip === empresaVida;

              const deductionData =
                user?.tenant_extra_field_id?.deduction_cert_data
                  ?.company_info || [];
              const payslipDate = payslip?.date;

              let isSalaryMatch = false;
              let isSalaryDataAvailable = false;

              if (payslipDate) {
                const [day, month, year] = payslipDate.includes("-")
                  ? payslipDate.split("-").length === 3 &&
                    payslipDate.split("-")[2].length === 4
                    ? payslipDate.split("-")
                    : payslipDate.split("-").reverse()
                  : ["", "", ""];

                const monthKey = getMonthKey(parseInt(month));
                const targetYear = year;

                for (const company of deductionData) {
                  const yearObj = company?.year;
                  const salaryValue = yearObj?.[targetYear]?.[monthKey];

                  if (salaryValue) {
                    isSalaryDataAvailable = true;

                    if (
                      normalizeSalary(salaryValue) ===
                      normalizeSalary(payslip?.netSalary)
                    ) {
                      isSalaryMatch = true;
                      break;
                    }
                  }
                }
              }

              const hasBothData =
                isEmployerDataAvailable && isSalaryDataAvailable;
              const hasAnyData =
                isEmployerDataAvailable || isSalaryDataAvailable;

              const isBothMatch = isEmployerMatch && isSalaryMatch;
              const isEitherMismatch =
                (isEmployerDataAvailable && !isEmployerMatch) ||
                (isSalaryDataAvailable && !isSalaryMatch);

              return (
                <div className="d-flex payslip-style">
                  <div
                    className={`d-flex payslip-style ${allowIncomeSourceChange ? "cursor-pointer" : ""
                      } ${showIncomeHighlight && highlightedPayslip === "payslip3"
                        ? "highlight-paymentslip"
                        : ""
                      }`}
                    onClick={() =>
                      allowIncomeSourceChange
                        ? handlePayslipChange("payslip3")
                        : {}
                    }
                  >
                    <span className="payslip-font-size-salary">
                      €{convertCurrencyFormat(payslip?.netSalary)}
                    </span>
                    <span className="paysip-date payslip-font-size">
                      {payslip?.date
                        ? `(${moment(payslip.date, "DD-MM-YYYY").format(
                          "MMM, YYYY"
                        )})`
                        : ""}
                    </span>
                  </div>

                  {!hasAnyData ? null : (hasBothData && isBothMatch) ||
                    (!isEmployerDataAvailable &&
                      isSalaryDataAvailable &&
                      isSalaryMatch) ||
                    (!isSalaryDataAvailable &&
                      isEmployerDataAvailable &&
                      isEmployerMatch) ? (
                    <img src={tickIcon} alt="match" />
                  ) : isEitherMismatch ? (
                    <ul className="infodorpdown summarydropdum position-relative">
                      <li>
                        <button className="iconinfo iconinfo2 m-0">
                          <img src={exclamationIcon} alt="mismatch" />
                        </button>
                      </li>
                      <ul className="tooltip tooltip2">
                        {isEmployerDataAvailable && !isEmployerMatch && (
                          <p>{_t("companyNotMatch")}</p>
                        )}
                        {isSalaryDataAvailable && !isSalaryMatch && (
                          <p>{_t("salaryMismatch")}</p>
                        )}
                      </ul>
                    </ul>
                  ) : null}
                </div>
              );
            })()}
        </div>
      </Col>
    </>
  );
};

export const toCamelCase = (str) => {
  return str
    .replace(/[^\w\s]/g, "")
    .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) =>
      index === 0 ? match.toLowerCase() : match.toUpperCase()
    )
    .replace(/\s+/g, "");
};

export const validatePhoneNumber = (fullPhoneNumber) => {
  try {
    const phoneNumberWithPlus = `+${fullPhoneNumber}`;
    const phoneNumberObject = parsePhoneNumberFromString(phoneNumberWithPlus);
    if (phoneNumberObject && phoneNumberObject.isValid()) {
      return { isValid: true, message: "Valid phone number" };
    }
    return { isValid: false, message: "Invalid phone number." };
  } catch (error) {
    return { isValid: false, message: "Invalid phone number" };
  }
};

export const calculateEffortRate = (user_income, user, profile_data) => {
  if (haveValue(user_income) && haveValue(user)) {
    const percentage = haveValue(profile_data?.rent_percentage)
      ? profile_data?.rent_percentage
      : user?.rent_percentage;
    const effortAmount = (user_income * (percentage ?? 0)) / 100;
    return {
      annual_sal: user_income * 12,
      monthly_sal: user_income,
      effort_rate: percentage ?? 0,
      effort_amount: parseFloat(effortAmount.toFixed(2)),
    };
    // let one_month_sal = user_income;
    // let effort_perc = (rent / one_month_sal) * 100;
    // return {
    //   annual_sal: user_income * 12,
    //   monthly_sal: one_month_sal,
    //   // effort_rate: effort_perc,
    //   effort_rate: parseFloat(effort_perc.toFixed(2)),
    //   // effort_amount: (one_month_sal * effort_perc) / 100,
    //   effort_amount: rent,
    // };
  } else {
    return {
      annual_sal: "N/A",
      monthly_sal: "N/A",
      effort_rate: "N/A",
      effort_amount: "N/A",
    };
  }
};

export function nl2br(str) {
  if (typeof str !== "string") return "";
  return str.replace(/\n/g, "<br>");
}

export function nl2ul(str, UlClass = "") {
  if (typeof str !== "string") return "";

  const items = str
    .split("\n")
    .map((item) => item.trim())
    .filter((item) => item.length > 0); // remove empty lines

  if (items.length === 0) return "";

  const listItems = items
    .map((item) => `<li class="report-list-style summery_listing">${item}</li>`)
    .join("");

  return `<ul class=${UlClass}>${listItems}</ul>`;
}

export const payslipValidityCheck = (payslip_data, user) => {
  if (
    haveValue(payslip_data) &&
    verifyDniNie(user, payslip_data?.data?.nieDniNumber)
  ) {
    const payslip = payslip_data?.data;
    const situaciones = user?.vida_laboral_id?.response?.situaciones || [];

    const empresaVida = situaciones[0]?.nombreEmpresa
      ?.split(" ")[0]
      ?.toLowerCase();
    const empresaPayslip = payslip?.employer?.split(" ")[0]?.toLowerCase();

    const isEmployerDataAvailable = !!empresaVida && !!empresaPayslip;
    const isEmployerMatch = empresaPayslip === empresaVida;

    const deductionData =
      user?.tenant_extra_field_id?.deduction_cert_data?.company_info || [];
    const payslipDate = payslip?.date;

    let isSalaryMatch = false;
    let isSalaryDataAvailable = false;

    if (payslipDate) {
      const [day, month, year] = payslipDate.includes("-")
        ? payslipDate.split("-").length === 3 &&
          payslipDate.split("-")[2].length === 4
          ? payslipDate.split("-")
          : payslipDate.split("-").reverse()
        : ["", "", ""];

      const monthKey = getMonthKey(parseInt(month));
      const targetYear = year;

      for (const company of deductionData) {
        const yearObj = company?.year;
        const salaryValue = yearObj?.[targetYear]?.[monthKey];

        if (salaryValue) {
          isSalaryDataAvailable = true;

          if (
            normalizeSalary(salaryValue) === normalizeSalary(payslip?.netSalary)
          ) {
            isSalaryMatch = true;
            break;
          }
        }
      }
    }

    const hasBothData = isEmployerDataAvailable && isSalaryDataAvailable;
    const hasAnyData = isEmployerDataAvailable || isSalaryDataAvailable;

    const isBothMatch = isEmployerMatch && isSalaryMatch;

    return !hasAnyData
      ? null
      : (hasBothData && isBothMatch) ||
        (!isEmployerDataAvailable && isSalaryDataAvailable && isSalaryMatch) ||
        (!isSalaryDataAvailable && isEmployerDataAvailable && isEmployerMatch)
        ? true
        : false;
  } else {
    return false;
  }
};

export const showTickOnDoc = (docObject, user) => {
  if (!docObject) return false;

  if (docObject.from === "clave") return true;

  if (docObject.type === "Last annual Tax Report (Model 100)") return true;

  if (docObject.type === "national_identity_card_front") return true;

  if (docObject.type === "national_identity_card_back") return true;

  if (
    docObject.type === "1st month payslip" &&
    payslipValidityCheck(
      user?.tenant_extra_field_id?.payslip_data?.payslip1,
      user
    )
  )
    return true;

  if (
    docObject.type === "2nd month payslip" &&
    payslipValidityCheck(
      user?.tenant_extra_field_id?.payslip_data?.payslip2,
      user
    )
  )
    return true;

  if (
    docObject.type === "3rd month payslip" &&
    payslipValidityCheck(
      user?.tenant_extra_field_id?.payslip_data?.payslip3,
      user
    )
  )
    return true;

  return false;
};

// export const getIncomeForEffortRate = (user, landlordUser = null, _t) => {
//   if (
//     haveValue(landlordUser) &&
//     haveValue(landlordUser?.agency_id?.income_hierarchy)
//   ) {
//     return hierarchyBasedAmount(user, landlordUser, _t);
//   } else {
//     let tenantExtraField = user?.tenant_extra_field_id;
//     let guarantorExtraField = user?.gurantor_id?.tenant_extra_field_id;
//     if (haveValue(user?.gurantor_id)) {
//       if (haveValue(user?.gurantor_id?.algoanIncome?.monthlyAmount)) {
//         return {
//           amount: Number(user?.gurantor_id?.algoanIncome?.monthlyAmount),
//           method: _t("bank")
//         };
//       }
//     }
//     else {
//       if (haveValue(user?.algoanIncome?.monthlyAmount)) {
//         return {
//           amount: Number(user?.algoanIncome?.monthlyAmount),
//           method: _t("bank")
//         }
//       }
//     }
//     // Check vals for modelo 100
//     if (haveValue(user?.gurantor_id)) {
//       if (
//         haveValue(user?.gurantor_id?.itr_status) &&
//         haveValue(user?.gurantor_id?.itr_amount) &&
//         user?.gurantor_id?.itr_status == "success"
//       ) {
//         if (verifyDniNie(user?.gurantor_id, user?.gurantor_id?.itr_dni_nie)) {
//           console.log("ITR");
//           return {
//             amount: Number(user?.gurantor_id?.itr_amount / 12),
//             method: _t("itr")
//           }
//         }
//       }
//     }
//     else {
//       if (
//         haveValue(user?.itr_status) &&
//         haveValue(user?.itr_amount) &&
//         user?.itr_status == "success"
//       ) {
//         if (verifyDniNie(user, user?.itr_dni_nie)) {
//           console.log("ITR");
//           return {
//             amount: Number(user?.itr_amount / 12),
//             method: _t("itr")
//           }
//         }
//       }
//     }
//     if (haveValue(user?.gurantor_id)) {
//       if (
//         haveValue(guarantorExtraField?.payslip_data?.payslip1?.data?.netSalary) ||
//         haveValue(guarantorExtraField?.payslip_data?.payslip2?.data?.netSalary) ||
//         haveValue(guarantorExtraField?.payslip_data?.payslip3?.data?.netSalary)
//       ) {
//         //Get the value of latest Payslip
//         let payslip_data = null;
//         if (
//           verifyDniNie(
//             user,
//             guarantorExtraField?.payslip_data?.payslip1?.data?.nieDniNumber
//           )
//         ) {
//           payslip_data = guarantorExtraField?.payslip_data?.payslip1?.data;
//         } else if (
//           verifyDniNie(
//             user,
//             guarantorExtraField?.payslip_data?.payslip2?.data?.nieDniNumber
//           )
//         ) {
//           payslip_data = guarantorExtraField?.payslip_data?.payslip2?.data;
//         } else if (
//           verifyDniNie(
//             user,
//             guarantorExtraField?.payslip_data?.payslip3?.data?.nieDniNumber
//           )
//         ) {
//           payslip_data = guarantorExtraField?.payslip_data?.payslip3?.data;
//         }

//         //Verify DNI/NIE with user and payslip else check in other method
//         if (haveValue(payslip_data)) {
//           console.log("Payslip", payslip_data);
//           return {
//             amount: payslip_data?.netSalary,
//             method: _t("payslip")
//           }
//         }
//       }
//     }
//     else {
//       if (
//         haveValue(tenantExtraField?.payslip_data?.payslip1?.data?.netSalary) ||
//         haveValue(tenantExtraField?.payslip_data?.payslip2?.data?.netSalary) ||
//         haveValue(tenantExtraField?.payslip_data?.payslip3?.data?.netSalary)
//       ) {
//         //Get the value of latest Payslip
//         let payslip_data = null;
//         if (
//           verifyDniNie(
//             user,
//             tenantExtraField?.payslip_data?.payslip1?.data?.nieDniNumber
//           )
//         ) {
//           payslip_data = tenantExtraField?.payslip_data?.payslip1?.data;
//         } else if (
//           verifyDniNie(
//             user,
//             tenantExtraField?.payslip_data?.payslip2?.data?.nieDniNumber
//           )
//         ) {
//           payslip_data = tenantExtraField?.payslip_data?.payslip2?.data;
//         } else if (
//           verifyDniNie(
//             user,
//             tenantExtraField?.payslip_data?.payslip3?.data?.nieDniNumber
//           )
//         ) {
//           payslip_data = tenantExtraField?.payslip_data?.payslip3?.data;
//         }

//         //Verify DNI/NIE with user and payslip else check in other method
//         if (haveValue(payslip_data)) {
//           console.log("Payslip");
//           return {
//             amount: payslip_data?.grossSalary,
//             method: _t("payslip")
//           }
//         }
//       }
//     }
//     if (haveValue(user?.gurantor_id)) {
//       if (haveValue(user?.gurantor_id?.current_annual_income)) {
//         console.log("Annual Income");
//         return {
//           amount: user?.gurantor_id?.current_annual_income / 12,
//           method: _t("declaredIncome")
//         }
//       }
//     }
//     else {
//       if (haveValue(user?.current_annual_income)) {
//         console.log("Annual Income");
//         return {
//           amount: user?.current_annual_income / 12,
//           method: _t("declaredIncome")
//         }
//       }
//     }
//     return null;
//   }
// };

export const getCustomIncome = (
  user,
  landlordUser = null,
  _t,
  incomeSource
) => {
  let tenantExtraField = user?.tenant_extra_field_id;

  switch (incomeSource) {
    case "bank": {
      if (haveValue(user?.algoanIncome?.monthlyAmount)) {
        // console.log("bank switch case");
        return {
          amount: Math.round(user.algoanIncome.monthlyAmount),
          method: _t("bank"),
          source: "bank",
        };
      }
      break;
    }

    case "payslip1": {
      const net = tenantExtraField?.payslip_data?.payslip1?.data?.netSalary;
      if (haveValue(net)) {
        // console.log("payslip1 switch case");
        return {
          amount: Math.round(net),
          method: _t("payslip"),
          source: "payslip1",
        };
      }
      break;
    }

    case "payslip2": {
      const net = tenantExtraField?.payslip_data?.payslip2?.data?.netSalary;
      if (haveValue(net)) {
        // console.log("payslip2 switch case");
        return {
          amount: Math.round(net),
          method: _t("payslip"),
          source: "payslip2",
        };
      }
      break;
    }

    case "payslip3": {
      const net = tenantExtraField?.payslip_data?.payslip3?.data?.netSalary;
      if (haveValue(net)) {
        // console.log("payslip3 switch case");
        return {
          amount: Math.round(net),
          method: _t("payslip"),
          source: "payslip3",
        };
      }
      break;
    }

    case "itr": {
      if (haveValue(user?.itr_amount)) {
        // console.log("itr switch case");
        return {
          amount: Math.round(user.itr_amount / 12),
          method: _t("itr"),
          source: "itr",
        };
      }
      break;
    }

    case "declaredIncome": {
      if (haveValue(user?.current_annual_income)) {
        // console.log("declaredIncome switch case");
        return {
          amount: Math.round((user.current_annual_income ?? 0) / 12),
          method: _t("declaredIncome"),
          source: "declaredIncome",
        };
      }
      break;
    }

    default: {
      return getIncomeForEffortRate(user, landlordUser, _t);
    }
  }

  // If none of the cases returned (because data wasn't valid), fallback
  return getIncomeForEffortRate(user, landlordUser, _t);
};

/*

    case "payslip1": {
      const net = tenantExtraField?.payslip_data?.payslip1?.data?.netSalary;
      console.log("net>>>>>>", net);
      if (haveValue(net)) {
        console.log("payslip1 switch case");
        return {
          amount: Math.round(net),
          method: _t("payslip"),
          source: "payslip1",
        };
      }
      break;
    }

    case "payslip2": {
      const net = tenantExtraField?.payslip_data?.payslip2?.data?.netSalary;
      if (haveValue(net)) {
        console.log("payslip2 switch case");
        return {
          amount: Math.round(net),
          method: _t("payslip"),
          source: "payslip2",
        };
      }
      break;
    }

    case "payslip3": {
      const net = tenantExtraField?.payslip_data?.payslip3?.data?.netSalary;
      if (haveValue(net)) {
        console.log("payslip3 switch case");
        return {
          amount: Math.round(net),
          method: _t("payslip"),
          source: "payslip3",
        };
      }
      break;
    }
*/

const getAllIncomeSources = (user, forensic_analysis) => {
  return {
    _id: user?._id,
    name: `${user?.fname ?? ""} ${user?.lname ?? ""}`,
    declaredIncome: Math.round(user?.current_annual_income ?? 0),
    itr: Math.round(
      (+(
        forensic_analysis?.["Tax returns"]?.dataInJSON?.savingBaseIncome ?? 0
      ) +
        +(forensic_analysis?.["Tax returns"]?.dataInJSON?.taxBaseIncome ?? 0)) /
      12
    ),
    bank: Math.round(user?.algoanIncome?.monthlyAmount ?? 0),
    ...Object.fromEntries(
      (forensic_analysis?.Income?.dataInJSON?.payslips || [])
        .filter((p) => p.date && typeof p.incomeFromPaySlip === "number")
        .map((p) => [`payslip:${p.date}`, Math.round(p.incomeFromPaySlip)])
    ),
  };
};

export const getCustomIncomeDetails = (
  user,
  landlordUser = null,
  _t,
  incomeSource = "declaredIncome"
) => {
  let forensic_analysis = {};
  if (
    haveValue(user) &&
    haveValue(user?.tenant_extra_field_id?.forensic_analysis)
  ) {
    const kycDetails = getIdentityDetails(user, user?.onfido_user_kyc);
    const allReports =
      user?.tenant_extra_field_id?.forensic_analysis?.profileReports ?? [];

    let matchedReport;

    if (haveValue(kycDetails.value)) {
      matchedReport =
        allReports.find((report) =>
          report?.report?.keyFactors?.keyFactors?.some((kf) => {
            const isMatch =
              kf?.keyFactor === "DNI" &&
              kf?.value?.toLowerCase() === kycDetails.value.toLowerCase();

            return isMatch;
          })
        ) || allReports[0];
    } else {
      matchedReport = allReports[0];
    }

    const temp_data = matchedReport?.report;
    const temp_key = {};
    temp_data?.keyFactors?.keyFactors.map((val) => {
      temp_key[val.keyFactor] = val;
    });
    forensic_analysis = temp_key;
  }
  const temp_all_sources = getAllIncomeSources(user, forensic_analysis);

  switch (true) {
    case incomeSource === "bank": {
      if (haveValue(user?.algoanIncome?.monthlyAmount)) {
        // console.log("bank switch case");
        return {
          amount: Math.round(user?.algoanIncome?.monthlyAmount ?? 0),
          method: _t("bank"),
          source: "bank",
          all_sources: temp_all_sources,
        };
      }
      break;
    }

    case incomeSource === "itr": {
      if (haveValue(forensic_analysis?.["Tax returns"])) {
        console.log("itr switch case");
        const monthAmount =
          ((+forensic_analysis?.["Tax returns"]?.dataInJSON?.savingBaseIncome ??
            0) +
            (+forensic_analysis?.["Tax returns"]?.dataInJSON?.taxBaseIncome ??
              0)) /
          12;
        return {
          amount: Math.round(monthAmount),
          method: _t("itr"),
          source: "itr",
          all_sources: temp_all_sources,
        };
      }
      break;
    }

    case incomeSource === "declaredIncome": {
      if (haveValue(user?.current_annual_income)) {
        return {
          amount: Math.round((user.current_annual_income ?? 0) / 12),
          method: _t("declaredIncome"),
          source: "declaredIncome",
          all_sources: temp_all_sources,
        };
      }
      break;
    }

    case incomeSource.startsWith("payslip:"): {
      const targetMonth = incomeSource.split(":")[1]; // e.g., "June 2025"
      const payslips = forensic_analysis?.Income?.dataInJSON?.payslips;

      if (Array.isArray(payslips)) {
        const selectedPayslip = payslips.find((p) => p.date === targetMonth);
        if (
          selectedPayslip &&
          typeof selectedPayslip.incomeFromPaySlip === "number"
        ) {
          console.log("payslip switch case for", targetMonth);
          return {
            amount: Math.round(selectedPayslip.incomeFromPaySlip),
            method: _t("payslip"),
            source: "payslip",
            all_sources: temp_all_sources,
          };
        }
      }
      break;
    }
  }

  // If none of the cases returned (because data wasn't valid), fallback
  return getIncomeForEffortRateNew(user, landlordUser, _t);
};

export const getIncomeForEffortRateNew = (user, landlordUser = null, _t) => {
  if (
    haveValue(landlordUser) &&
    haveValue(landlordUser?.agency_id?.income_hierarchy)
  ) {
    return hierarchyBasedAmount(user, landlordUser, _t);
  } else {
    let tenantExtraField = user?.tenant_extra_field_id;

    // bank
    if (haveValue(user?.algoanIncome?.monthlyAmount)) {
      return {
        amount: Math.round(user?.algoanIncome?.monthlyAmount),
        method: _t("bank"),
        source: "bank",
      };
    }

    // payslips
    if (
      haveValue(tenantExtraField?.payslip_data?.payslip1?.data?.netSalary) ||
      haveValue(tenantExtraField?.payslip_data?.payslip2?.data?.netSalary) ||
      haveValue(tenantExtraField?.payslip_data?.payslip3?.data?.netSalary)
    ) {
      //Get the value of latest Payslip
      let payslip_data = null;
      let source = null;
      if (
        verifyDniNie(
          user,
          tenantExtraField?.payslip_data?.payslip1?.data?.nieDniNumber
        )
      ) {
        payslip_data = tenantExtraField?.payslip_data?.payslip1?.data;
        source = "payslip1";
      } else if (
        verifyDniNie(
          user,
          tenantExtraField?.payslip_data?.payslip2?.data?.nieDniNumber
        )
      ) {
        payslip_data = tenantExtraField?.payslip_data?.payslip2?.data;
        source = "payslip2";
      } else if (
        verifyDniNie(
          user,
          tenantExtraField?.payslip_data?.payslip3?.data?.nieDniNumber
        )
      ) {
        payslip_data = tenantExtraField?.payslip_data?.payslip3?.data;
        source = "payslip3";
      }

      //Verify DNI/NIE with user and payslip else check in other method
      if (haveValue(payslip_data)) {
        return {
          amount: Math.round(payslip_data?.netSalary),
          method: _t("payslip"),
          source,
        };
      }
    }

    // Check vals for modelo 100
    if (
      haveValue(user?.itr_status) &&
      haveValue(user?.itr_amount) &&
      user?.itr_status == "success"
    ) {
      if (verifyDniNie(user, user?.itr_dni_nie)) {
        return {
          amount: Math.round((user?.itr_amount ?? 0) / 12),
          method: _t("itr"),
          source: "itr",
        };
      }
    }

    // declared income
    if (haveValue(user?.current_annual_income)) {
      return {
        amount: Math.round((user?.current_annual_income ?? 0) / 12),
        method: _t("declaredIncome"),
        source: "declaredIncome",
      };
    }
    return {
      amount: 0,
      method: _t("noIncomeSource"),
      source: "noIncomeSource",
    };
  }
};
export const getIncomeForEffortRate = (user, landlordUser = null, _t) => {
  if (
    haveValue(landlordUser) &&
    haveValue(landlordUser?.agency_id?.income_hierarchy)
  ) {
    return hierarchyBasedAmount(user, landlordUser, _t);
  } else {
    let tenantExtraField = user?.tenant_extra_field_id;

    // bank
    if (haveValue(user?.algoanIncome?.monthlyAmount)) {
      return {
        amount: Math.round(user?.algoanIncome?.monthlyAmount),
        method: _t("bank"),
        source: "bank",
      };
    }

    // payslips
    if (
      haveValue(tenantExtraField?.payslip_data?.payslip1?.data?.netSalary) ||
      haveValue(tenantExtraField?.payslip_data?.payslip2?.data?.netSalary) ||
      haveValue(tenantExtraField?.payslip_data?.payslip3?.data?.netSalary)
    ) {
      //Get the value of latest Payslip
      let payslip_data = null;
      let source = null;
      if (
        verifyDniNie(
          user,
          tenantExtraField?.payslip_data?.payslip1?.data?.nieDniNumber
        )
      ) {
        payslip_data = tenantExtraField?.payslip_data?.payslip1?.data;
        source = "payslip1";
      } else if (
        verifyDniNie(
          user,
          tenantExtraField?.payslip_data?.payslip2?.data?.nieDniNumber
        )
      ) {
        payslip_data = tenantExtraField?.payslip_data?.payslip2?.data;
        source = "payslip2";
      } else if (
        verifyDniNie(
          user,
          tenantExtraField?.payslip_data?.payslip3?.data?.nieDniNumber
        )
      ) {
        payslip_data = tenantExtraField?.payslip_data?.payslip3?.data;
        source = "payslip3";
      }

      //Verify DNI/NIE with user and payslip else check in other method
      if (haveValue(payslip_data)) {
        return {
          amount: Math.round(payslip_data?.netSalary),
          method: _t("payslip"),
          source,
        };
      }
    }

    // Check vals for modelo 100
    if (
      haveValue(user?.itr_status) &&
      haveValue(user?.itr_amount) &&
      user?.itr_status == "success"
    ) {
      if (verifyDniNie(user, user?.itr_dni_nie)) {
        return {
          amount: Math.round((user?.itr_amount ?? 0) / 12),
          method: _t("itr"),
          source: "itr",
        };
      }
    }

    // declared income
    if (haveValue(user?.current_annual_income)) {
      return {
        amount: Math.round((user?.current_annual_income ?? 0) / 12),
        method: _t("declaredIncome"),
        source: "declaredIncome",
      };
    }
    return {
      amount: 0,
      method: _t("noIncomeSource"),
      source: "noIncomeSource",
    };
  }
};

const hierarchyBasedAmount = (user, landlordUser, _t) => {
  let tenantExtraField = user?.tenant_extra_field_id;
  for (let type of landlordUser?.agency_id?.income_hierarchy) {
    if (type == "itr_amount") {
      if (
        haveValue(user?.itr_status) &&
        haveValue(user?.itr_amount) &&
        user?.itr_status == "success"
      ) {
        if (verifyDniNie(user, user?.itr_dni_nie)) {
          console.log("ITR");
          return {
            amount: Math.round(user?.itr_amount / 12),
            method: _t("itr"),
            source: "itr",
          };
        }
      }
    } else if (type == "payslip_data") {
      if (
        haveValue(tenantExtraField?.payslip_data?.payslip1?.data?.netSalary) ||
        haveValue(tenantExtraField?.payslip_data?.payslip2?.data?.netSalary) ||
        haveValue(tenantExtraField?.payslip_data?.payslip3?.data?.netSalary)
      ) {
        //Get the value of latest Payslip
        let payslip_data = null;
        let source = null;
        if (
          verifyDniNie(
            user,
            tenantExtraField?.payslip_data?.payslip1?.data?.nieDniNumber
          )
        ) {
          payslip_data = tenantExtraField?.payslip_data?.payslip1?.data;
          source = "payslip1";
        } else if (
          verifyDniNie(
            user,
            tenantExtraField?.payslip_data?.payslip2?.data?.nieDniNumber
          )
        ) {
          payslip_data = tenantExtraField?.payslip_data?.payslip2?.data;
          source = "payslip2";
        } else if (
          verifyDniNie(
            user,
            tenantExtraField?.payslip_data?.payslip3?.data?.nieDniNumber
          )
        ) {
          payslip_data = tenantExtraField?.payslip_data?.payslip3?.data;
          source = "payslip3";
        }

        //Verify DNI/NIE with user and payslip else check in other method
        if (haveValue(payslip_data)) {
          console.log("Payslip");
          return {
            amount: Math.round(payslip_data?.netSalary),
            method: _t("payslip"),
            source,
          };
        }
      }
    } else if (type == "algoanIncome") {
      if (haveValue(user?.algoanIncome?.monthlyAmount)) {
        return {
          amount: Math.round(user?.algoanIncome?.monthlyAmount),
          method: _t("bank"),
          source: "bank",
        };
      }
    } else {
      if (haveValue(user?.current_annual_income)) {
        console.log("Annual Income");
        return {
          amount: Math.round((user?.current_annual_income ?? 0) / 12),
          method: _t("declaredIncome"),
          source: "declaredIncome",
        };
      } else {
        return {
          amount: 0,
          method: _t("noIncomeSource"),
          source: "noIncomeSource",
        };
      }
    }
  }
};

export function isObject(value) {
  return value !== null && typeof value === "object" && !Array.isArray(value);
}

export const checkSalary = (user = {}) => {
  if (user?.algoanIncome) {
    let monthlyIncome = parseInt(user?.algoanIncome?.monthlyAmount);
    let recorded_annual_salary = monthlyIncome * 12;

    let userIncome = parseInt(
      haveValue(user.current_annual_income) ? user.current_annual_income : 0
    );
    let salaryMatch = Math.round((recorded_annual_salary / userIncome) * 100);

    return {
      matched: salaryMatch,
      salary: recorded_annual_salary,
    };
  }
};

export const isDefaulter = (experianData) => {
  if (
    !experianData ||
    !experianData.ResumenCais ||
    typeof experianData.ResumenCais !== "object"
  ) {
    return "no";
  }

  const keysToCheck = [
    "NumeroOperacionesImpagadas",
    "NumeroCuotasImpagadas",
    "ImporteImpagado",
    "MaximoImporteImpagado",
  ];

  for (let key of keysToCheck) {
    const value = parseInt(experianData.ResumenCais[key]);
    if (!isNaN(value) && value > 0) {
      return "yes";
    }
  }

  return "no";
};

export const formatToStandardDate = (dateInput) => {
  if (!dateInput) return dateInput;

  // Normalize input to string and trim
  const dateStr = typeof dateInput === "string" ? dateInput.trim() : dateInput;

  // Try parsing common formats first
  let m = moment(
    dateStr,
    ["DD/MM/YYYY", "MM/YYYY", "YYYY-MM-DD", "MMM YYYY", "MMMM YYYY"],
    true
  );

  // Fallback to native Date if moment fails
  if (!m.isValid()) {
    m = moment(new Date(dateStr));
  }

  // Final check
  return m.isValid() ? m.format("MMM YYYY") : dateInput;
};

export const getIdentityDetails = (user, userKycInfo) => {
  const kyc = userKycInfo?.onfido_doc_data;

  if (
    haveValue(kyc?.personal_number) &&
    kyc?.document_issuing_country === "ESP" &&
    kyc?.document_type !== "passport"
  ) {
    return {
      type: "dni",
      value: kyc.personal_number,
      showTick: true,
    };
  }

  if (haveValue(kyc?.document_number) && kyc?.document_type === "passport") {
    return {
      type: "passport",
      value: kyc.document_number,
      showTick: true,
    };
  }

  if (haveValue(user?.dni_nie)) {
    return {
      type: "dni",
      value: user.dni_nie,
      showTick: false,
    };
  }

  return {
    type: "passport",
    value: user?.passport_id ?? "",
    showTick: false,
  };
};
